import React from 'react';
import Container from 'react-bootstrap/Container';

import * as styles from './styles.module.scss';

interface SiteReviewsProps {
	title: string;
	children: React.ReactNode;
}

const SiteReviews: React.FC<SiteReviewsProps> = ({title, children}) => {
	return (
		<Container className={'p-0'} fluid>
			<div className={styles.siteReviews}>
				<h4>{title}</h4>
				<div className={styles.reviews}>
					{children}
				</div>
			</div>
		</Container>
	);
};

export default SiteReviews;
